<template lang="html">
  <div>
    <div id="fb-root"></div>
    <div
      class="fb-login-button"
      data-max-rows="1"
      data-size="large"
      data-width="306px"
      data-button-type="continue_with"
      data-show-faces="false"
      data-auto-logout-link="false"
      data-use-continue-as="true"
    />
  </div>


  <!-- <v-btn class="fb-login-button" @click="login" :disabled="disabled" data-size="large" data-button-type="continue_with" data-show-faces="false" data-auto-logout-link="false" data-use-continue-as="true">
    <strong>
        <slot>Login with Facebook</slot>
      </strong>
  </v-btn> -->
</template>

<script>
import { isNil } from 'lodash';

export default {
  props: {
    facebookAppId: {
      desc: 'The app id against which access token will be granted',
      type: String,
    },
    callback: {
      desc: 'function to call with the access token',
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      sdkLoaded: false,
    };
  },
  methods: {
    setupFacebookClient() {
      // initialize the facebook sdk
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: this.facebookAppId,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v3.1',
        });

        // on the callback has been triggerd and the init function called
        // mark the sdk as loaded
        this.sdkLoaded = true;
        window.FB.Event.subscribe('auth.login', this.login);
        window.FB.Event.subscribe('auth.authResponseChange', this.login);
      };

      // setup facebook configuration
      const id = 'facebook-jssdk';
      const tagName = 'script';
      const fjs = document.getElementsByTagName(tagName)[0];
      if (document.getElementById(id)) {
        return;
      }
      const js = document.createElement(tagName);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    },
    login(response) {
      // window.FB.login((response) => {
      //   this.callback(response.authResponse.accessToken);
      // });
      this.callback(response.authResponse.accessToken);
    },
  },
  watch: {
    facebookAppId(val) {
      // enable the facebook integration when app id is provided
      if (!isNil(val)) {
        this.setupFacebookClient();
      }
    },
  },
  computed: {
    disabled() {
      return isNil(this.facebookAppId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
    .fb-login-button {
      min-width: 306px;
      max-width: 350px;
      // margin-top: 3.6%;
      // margin-left: 17%;
      // margin-right: 17%;
      // border-radius: 100px;
      // color: $blue;
      // background-color: $white !important;
      // border-color: $border-color;
      // box-shadow: 0 4px 8px 0 $border-color;
      // font-family: MuseoSans-500;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/FacebookLogin.vue